import {
  EstadoDeCarpetasDoreSchema,
  ExpedienteDoreSchema,
  ModeloDeCarpetaDoreSchema,
  ResultadoDeRevisionDeCarpetasDoreSchema,
  type ConfiguracionDeCarpetasDore,
} from '@cnc/contracts';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {json, pedir} from './cliente';

// Carpetas de las exportaciones de dore en Dropbox y su expediente (decision 0095).
export function useEstadoDeCarpetasDore() {
  return useQuery({
    queryKey: ['carpetas', 'dore', 'estado'],
    queryFn: () => pedir('dore/carpetas/estado', EstadoDeCarpetasDoreSchema),
  });
}

export function useGuardarCarpetasDore() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (c: ConfiguracionDeCarpetasDore) =>
      pedir('dore/carpetas/configuracion', EstadoDeCarpetasDoreSchema, json('PUT', c)),
    onSuccess: () => cliente.invalidateQueries({queryKey: ['carpetas']}),
  });
}

export function useModeloDeCarpetaDore() {
  return useMutation({
    mutationFn: (ruta: string) => pedir('dore/carpetas/modelo', ModeloDeCarpetaDoreSchema, json('POST', {ruta})),
  });
}

export function useRevisarCarpetasDore() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: () => pedir('dore/carpetas/revisar', ResultadoDeRevisionDeCarpetasDoreSchema, json('POST')),
    onSuccess: () => cliente.invalidateQueries({queryKey: ['carpetas']}),
  });
}

const rutaDelExpediente = (codigo: string) => `dore/exportaciones/${encodeURIComponent(codigo)}/expediente`;

export function useExpedienteDore(codigo: string) {
  return useQuery({
    queryKey: ['dore', 'expediente', codigo],
    queryFn: () => pedir(rutaDelExpediente(codigo), ExpedienteDoreSchema),
  });
}

export function useSubirAlExpedienteDore(codigo: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({archivo, categoria}: {archivo: File; categoria: string}) => {
      const cuerpo = new FormData();
      cuerpo.append('archivo', archivo, archivo.name);
      cuerpo.append('categoria', categoria);
      return pedir(rutaDelExpediente(codigo), ExpedienteDoreSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({queryKey: ['dore', 'expediente', codigo]});
      await cliente.invalidateQueries({queryKey: ['carpetas', 'archivos', codigo]});
    },
  });
}

export function useBorrarDelExpedienteDore(codigo: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => pedir(`dore/expediente/${id}`, ExpedienteDoreSchema, json('DELETE')),
    onSuccess: async () => {
      await cliente.invalidateQueries({queryKey: ['dore', 'expediente', codigo]});
      await cliente.invalidateQueries({queryKey: ['carpetas', 'archivos', codigo]});
    },
  });
}

export const rutaDelDocumentoDore = (id: number) => `/api/dore/expediente/${id}/archivo`;
export const rutaDeLaVistaDore = (id: number) => `/api/dore/expediente/${id}/vista`;
